import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

const es = {
  NavBar: {
    Home: "Inicio",
    About: "Nosotros",
    Mission: "Misión",
    Vision: "Visión",
    Team: "Equipo",
    Contact: "Contacto",
    ContactBtn: "Contáctanos",
  },
  Hero: {
    badge: "Soluciones Tecnológicas para Guatemala y Centroamérica",
    title1: "Transformamos",
    titleGradient: "tu negocio",
    title2: "con tecnología",
    subtitle:
      "Somos un equipo de expertos en tecnología dedicados a impulsar el crecimiento digital de empresas en Guatemala y toda Centroamérica.",
    cta1: "Conoce más",
    cta2: "Nuestro equipo",
    scroll: "Scroll",
    stats: { projects: "Proyectos", clients: "Clientes", experience: "Años de experiencia" },
  },
  About: {
    label: "Acerca de nosotros",
    title1: "Innovación que",
    titleGradient: "conecta",
    title2: "el futuro",
    p1: "SIS-GT Tecnología nació con la visión de cerrar la brecha digital en Guatemala y Centroamérica, ofreciendo soluciones tecnológicas de clase mundial adaptadas a la realidad de nuestra región.",
    p2: "Combinamos talento local con metodologías internacionales para entregar proyectos que generan un impacto real y medible en los negocios de nuestros clientes.",
    tags: ["Cloud Computing", "IA & Automatización", "Seguridad", "Desarrollo Ágil"],
  },
  Services: {
    items: [
      { name: "Desarrollo de Software", description: "Creamos soluciones a la medida de tu negocio con las tecnologías más modernas del mercado." },
      { name: "Infraestructura Cloud",  description: "Migra y escala tus operaciones en la nube con arquitecturas seguras y de alto rendimiento." },
      { name: "Automatización",         description: "Optimizamos tus procesos con inteligencia artificial y automatización de flujos de trabajo." },
      { name: "Consultoría TI",         description: "Asesoramiento estratégico para que tomes las mejores decisiones tecnológicas." },
      { name: "Soporte 24/7",           description: "Monitoreo continuo y soporte técnico especializado para mantener tu negocio operando." },
    ],
  },
  Pillars: {
    label: "Nuestros pilares",
    title: "Propósito y dirección",
    mission: {
      title: "Misión",
      text: "Brindar soluciones tecnológicas innovadoras y de alta calidad que potencien la competitividad de las empresas centroamericanas, democratizando el acceso a la tecnología de vanguardia con un servicio cercano, confiable y a la medida.",
      tags: ["Innovación", "Calidad", "Compromiso"],
    },
    vision: {
      title: "Visión",
      text: "Ser la empresa tecnológica de referencia en Centroamérica, reconocida por transformar negocios a través de la digitalización inteligente, creando un ecosistema tecnológico que impulse el desarrollo económico y social de la región.",
      tags: ["Liderazgo", "Impacto", "Futuro"],
    },
    values: [
      { title: "Excelencia",    desc: "Entregamos más de lo que prometemos" },
      { title: "Transparencia", desc: "Comunicación honesta en todo momento" },
      { title: "Agilidad",      desc: "Nos adaptamos rápido a los cambios" },
      { title: "Colaboración",  desc: "Crecemos juntos con nuestros clientes" },
    ],
  },
  Team: {
    label: "Nuestro equipo",
    title1: "Las personas detrás de",
    subtitle: "Un equipo apasionado por la tecnología y comprometido con el éxito de cada cliente.",
    members: [
      { name: "Leonel Madrid", role: "CEO & Fundador",                 initials: "LM", bio: "Experto en soluciones tecnológicas con más de 10 años liderando proyectos de transformación digital en Centroamérica." },
      { name: "Jorge Laj",     role: "CTO & Full Stack Developer",     initials: "JL", bio: "Especialista en desarrollo full stack y arquitectura de sistemas con amplia experiencia en tecnologías cloud y soluciones empresariales." },
      { name: "Luis Morales",   role: "CVO & DevOps",                  initials: "LM", bio: "Especialista en operaciones de desarrollo y visión de producto, con amplia experiencia en infraestructura cloud, automatización de procesos y entrega continua." },
      { name: "Gabriel Villatoro", role: "QA Tester",                  initials: "GV", bio: "Especialista en aseguramiento de calidad con experiencia en pruebas funcionales, automatizadas y de rendimiento para garantizar productos sin errores." },
      { name: "Alejandro Chinchilla", role: "Full Stack Developer",    initials: "AC", bio: "Desarrollador full stack con experiencia en el diseño y construcción de aplicaciones web completas, desde interfaces de usuario hasta servicios backend y bases de datos." },
      { name: "Jordin de León",   role: "Full Stack Developer",       initials: "JL", bio: "Desarrollador full stack con habilidades en el desarrollo de soluciones web integrales, integrando tecnologías modernas tanto en el frontend como en el backend." },
      { name: "Emanuel Paz",     role: "Full Stack Developer",         initials: "EP", bio: "Desarrollador full stack especializado en crear interfaces atractivas, intuitivas y responsivas, enfocado en brindar la mejor experiencia de usuario con tecnologías web modernas." },
      { name: "Keller Matta",    role: "Backend Developer",            initials: "KM", bio: "Desarrollador backend especializado en arquitecturas escalables, APIs robustas y optimización de bases de datos para aplicaciones de alto rendimiento." },
      { name: "Edwin Rodriguez",  role: "Backend Developer",            initials: "ER", bio: "Desarrollador backend con experiencia en construcción de servicios eficientes, integración de sistemas y despliegue de soluciones en entornos de producción." },
      { name: "Daniels Castillo", role: "Frontend Developer",           initials: "DC", bio: "Desarrollador frontend especializado en crear interfaces modernas, responsivas y con gran experiencia de usuario utilizando las últimas tecnologías web." },
    ],
  },
  Contact: {
    label: "Contáctanos",
    title1: "Hablemos de tu",
    titleGradient: "proyecto",
    subtitle: "Estamos listos para ayudarte a dar el siguiente paso en tu transformación digital.",
    form: {
      name: "Nombre",
      namePlaceholder: "Tu nombre",
      company: "Empresa",
      companyPlaceholder: "Tu empresa",
      email: "Correo electrónico",
      emailPlaceholder: "tu@empresa.com",
      service: "Servicio de interés",
      serviceDefault: "Selecciona un servicio",
      message: "Mensaje",
      messagePlaceholder: "Cuéntanos sobre tu proyecto...",
      submit: "Enviar mensaje",
    },
    info: {
      emailLabel: "Correo",
      phoneLabel: "Teléfono",
      locationLabel: "Ubicación",
    },
  },
  Footer: { rights: "Todos los derechos reservados." },
};

const en = {
  NavBar: {
    Home: "Home",
    About: "About",
    Mission: "Mission",
    Vision: "Vision",
    Team: "Team",
    Contact: "Contact",
    ContactBtn: "Contact Us",
  },
  Hero: {
    badge: "Technology Solutions for Guatemala and Central America",
    title1: "We transform",
    titleGradient: "your business",
    title2: "with technology",
    subtitle:
      "We are a team of technology experts dedicated to driving the digital growth of companies in Guatemala and all of Central America.",
    cta1: "Learn more",
    cta2: "Our team",
    scroll: "Scroll",
    stats: { projects: "Projects", clients: "Clients", experience: "Years of experience" },
  },
  About: {
    label: "About us",
    title1: "Innovation that",
    titleGradient: "connects",
    title2: "the future",
    p1: "SIS-GT Tecnología was born with the vision of closing the digital gap in Guatemala and Central America, offering world-class technology solutions adapted to the reality of our region.",
    p2: "We combine local talent with international methodologies to deliver projects that generate a real and measurable impact on our clients' businesses.",
    tags: ["Cloud Computing", "AI & Automation", "Security", "Agile Development"],
  },
  Services: {
    items: [
      { name: "Software Development", description: "We create custom solutions for your business using the most modern technologies on the market." },
      { name: "Cloud Infrastructure", description: "Migrate and scale your operations in the cloud with secure, high-performance architectures." },
      { name: "Automation",           description: "We optimize your processes with artificial intelligence and workflow automation." },
      { name: "IT Consulting",        description: "Strategic advice to help you make the best technology decisions." },
      { name: "24/7 Support",         description: "Continuous monitoring and specialized technical support to keep your business running." },
    ],
  },
  Pillars: {
    label: "Our pillars",
    title: "Purpose and direction",
    mission: {
      title: "Mission",
      text: "To provide innovative, high-quality technology solutions that enhance the competitiveness of Central American companies, democratizing access to cutting-edge technology with a close, reliable, and tailored service.",
      tags: ["Innovation", "Quality", "Commitment"],
    },
    vision: {
      title: "Vision",
      text: "To be the reference technology company in Central America, recognized for transforming businesses through intelligent digitization, creating a technological ecosystem that drives the economic and social development of the region.",
      tags: ["Leadership", "Impact", "Future"],
    },
    values: [
      { title: "Excellence",    desc: "We deliver more than we promise" },
      { title: "Transparency",  desc: "Honest communication at all times" },
      { title: "Agility",       desc: "We adapt quickly to change" },
      { title: "Collaboration", desc: "We grow together with our clients" },
    ],
  },
  Team: {
    label: "Our team",
    title1: "The people behind",
    subtitle: "A team passionate about technology and committed to the success of every client.",
    members: [
      { name: "Leonel Madrid", role: "CEO & Founder",            initials: "LM", bio: "Technology solutions expert with more than 10 years leading digital transformation projects in Central America." },
      { name: "Jorge Laj",     role: "CTO & Full Stack Developer", initials: "JL", bio: "Full stack development and systems architecture specialist with extensive experience in cloud technologies and enterprise solutions." },
      { name: "Luis Morales",   role: "CVO & DevOps",               initials: "LM", bio: "Development operations and product vision specialist with extensive experience in cloud infrastructure, process automation, and continuous delivery." },
      { name: "Gabriel Villatoro", role: "QA Tester",             initials: "GV", bio: "Quality assurance specialist with experience in functional, automated, and performance testing to ensure error-free products." },
      { name: "Alejandro Chinchilla", role: "Full Stack Developer", initials: "AC", bio: "Full stack developer with experience designing and building complete web applications, from user interfaces to backend services and databases." },
      { name: "Jordin de León",   role: "Full Stack Developer",    initials: "JL", bio: "Full stack developer skilled in building comprehensive web solutions, integrating modern technologies across both frontend and backend." },
      { name: "Emanuel Paz",     role: "Full Stack Developer",     initials: "EP", bio: "Full stack developer specialized in creating attractive, intuitive, and responsive interfaces, focused on delivering the best user experience with modern web technologies." },
      { name: "Keller Matta",    role: "Backend Developer",        initials: "KM", bio: "Backend developer specialized in scalable architectures, robust APIs, and database optimization for high-performance applications." },
      { name: "Edwin Rodriguez",  role: "Backend Developer",        initials: "ER", bio: "Backend developer with experience building efficient services, system integrations, and deploying solutions in production environments." },
      { name: "Daniels Castillo", role: "Frontend Developer",       initials: "DC", bio: "Frontend developer specialized in building modern, responsive interfaces with exceptional user experience using the latest web technologies." },
    ],
  },
  Contact: {
    label: "Contact Us",
    title1: "Let's talk about your",
    titleGradient: "project",
    subtitle: "We are ready to help you take the next step in your digital transformation.",
    form: {
      name: "Name",
      namePlaceholder: "Your name",
      company: "Company",
      companyPlaceholder: "Your company",
      email: "Email address",
      emailPlaceholder: "you@company.com",
      service: "Service of interest",
      serviceDefault: "Select a service",
      message: "Message",
      messagePlaceholder: "Tell us about your project...",
      submit: "Send message",
    },
    info: {
      emailLabel: "Email",
      phoneLabel: "Phone",
      locationLabel: "Location",
    },
  },
  Footer: { rights: "All rights reserved." },
};

const pt = {
  NavBar: {
    Home: "Início",
    About: "Sobre nós",
    Mission: "Missão",
    Vision: "Visão",
    Team: "Equipe",
    Contact: "Contato",
    ContactBtn: "Fale conosco",
  },
  Hero: {
    badge: "Soluções Tecnológicas para Guatemala e América Central",
    title1: "Transformamos",
    titleGradient: "seu negócio",
    title2: "com tecnologia",
    subtitle:
      "Somos uma equipe de especialistas em tecnologia dedicados a impulsionar o crescimento digital de empresas na Guatemala e em toda a América Central.",
    cta1: "Saiba mais",
    cta2: "Nossa equipe",
    scroll: "Role",
    stats: { projects: "Projetos", clients: "Clientes", experience: "Anos de experiência" },
  },
  About: {
    label: "Sobre nós",
    title1: "Inovação que",
    titleGradient: "conecta",
    title2: "o futuro",
    p1: "A SIS-GT Tecnología nasceu com a visão de reduzir a lacuna digital na Guatemala e na América Central, oferecendo soluções tecnológicas de classe mundial adaptadas à realidade da nossa região.",
    p2: "Combinamos talento local com metodologias internacionais para entregar projetos que geram impacto real e mensurável nos negócios dos nossos clientes.",
    tags: ["Cloud Computing", "IA & Automação", "Segurança", "Desenvolvimento Ágil"],
  },
  Services: {
    items: [
      { name: "Desenvolvimento de Software", description: "Criamos soluções personalizadas para o seu negócio com as tecnologias mais modernas do mercado." },
      { name: "Infraestrutura Cloud",        description: "Migre e escale suas operações na nuvem com arquiteturas seguras e de alto desempenho." },
      { name: "Automação",                   description: "Otimizamos seus processos com inteligência artificial e automação de fluxos de trabalho." },
      { name: "Consultoria TI",              description: "Assessoria estratégica para que você tome as melhores decisões tecnológicas." },
      { name: "Suporte 24/7",               description: "Monitoramento contínuo e suporte técnico especializado para manter seu negócio operando." },
    ],
  },
  Pillars: {
    label: "Nossos pilares",
    title: "Propósito e direção",
    mission: {
      title: "Missão",
      text: "Fornecer soluções tecnológicas inovadoras e de alta qualidade que potencializem a competitividade das empresas centro-americanas, democratizando o acesso à tecnologia de ponta com um serviço próximo, confiável e personalizado.",
      tags: ["Inovação", "Qualidade", "Compromisso"],
    },
    vision: {
      title: "Visão",
      text: "Ser a empresa tecnológica de referência na América Central, reconhecida por transformar negócios por meio da digitalização inteligente, criando um ecossistema tecnológico que impulsione o desenvolvimento econômico e social da região.",
      tags: ["Liderança", "Impacto", "Futuro"],
    },
    values: [
      { title: "Excelência",      desc: "Entregamos mais do que prometemos" },
      { title: "Transparência",   desc: "Comunicação honesta em todo momento" },
      { title: "Agilidade",       desc: "Nos adaptamos rapidamente às mudanças" },
      { title: "Colaboração",     desc: "Crescemos juntos com nossos clientes" },
    ],
  },
  Team: {
    label: "Nossa equipe",
    title1: "As pessoas por trás de",
    subtitle: "Uma equipe apaixonada por tecnologia e comprometida com o sucesso de cada cliente.",
    members: [
      { name: "Leonel Madrid",         role: "CEO & Fundador",               initials: "LM", bio: "Especialista em soluções tecnológicas com mais de 10 anos liderando projetos de transformação digital na América Central." },
      { name: "Jorge Laj",             role: "CTO & Full Stack Developer",   initials: "JL", bio: "Especialista em desenvolvimento full stack e arquitetura de sistemas com ampla experiência em tecnologias cloud e soluções empresariais." },
      { name: "Luis Morales",          role: "CVO & DevOps",                 initials: "LM", bio: "Especialista em operações de desenvolvimento e visão de produto, com ampla experiência em infraestrutura cloud, automação de processos e entrega contínua." },
      { name: "Gabriel Villatoro",     role: "QA Tester",                   initials: "GV", bio: "Especialista em garantia de qualidade com experiência em testes funcionais, automatizados e de desempenho para garantir produtos sem erros." },
      { name: "Alejandro Chinchilla", role: "Full Stack Developer",          initials: "AC", bio: "Desenvolvedor full stack com experiência no design e construção de aplicações web completas, desde interfaces de usuário até serviços backend e bancos de dados." },
      { name: "Jordin de León",        role: "Full Stack Developer",         initials: "JL", bio: "Desenvolvedor full stack com habilidades no desenvolvimento de soluções web abrangentes, integrando tecnologias modernas tanto no frontend quanto no backend." },
      { name: "Emanuel Paz",           role: "Full Stack Developer",         initials: "EP", bio: "Desenvolvedor full stack especializado em criar interfaces atraentes, intuitivas e responsivas, focado em proporcionar a melhor experiência do usuário com tecnologias web modernas." },
      { name: "Keller Matta",          role: "Backend Developer",            initials: "KM", bio: "Desenvolvedor backend especializado em arquiteturas escaláveis, APIs robustas e otimização de bancos de dados para aplicações de alto desempenho." },
      { name: "Edwin Rodriguez",       role: "Backend Developer",            initials: "ER", bio: "Desenvolvedor backend com experiência na construção de serviços eficientes, integração de sistemas e implantação de soluções em ambientes de produção." },
      { name: "Daniels Castillo",      role: "Frontend Developer",           initials: "DC", bio: "Desenvolvedor frontend especializado em criar interfaces modernas, responsivas e com excelente experiência do usuário utilizando as mais recentes tecnologias web." },
    ],
  },
  Contact: {
    label: "Fale conosco",
    title1: "Vamos falar sobre seu",
    titleGradient: "projeto",
    subtitle: "Estamos prontos para ajudá-lo a dar o próximo passo em sua transformação digital.",
    form: {
      name: "Nome",
      namePlaceholder: "Seu nome",
      company: "Empresa",
      companyPlaceholder: "Sua empresa",
      email: "Endereço de e-mail",
      emailPlaceholder: "voce@empresa.com",
      service: "Serviço de interesse",
      serviceDefault: "Selecione um serviço",
      message: "Mensagem",
      messagePlaceholder: "Conte-nos sobre seu projeto...",
      submit: "Enviar mensagem",
    },
    info: {
      emailLabel: "E-mail",
      phoneLabel: "Telefone",
      locationLabel: "Localização",
    },
  },
  Footer: { rights: "Todos os direitos reservados." },
};

const zh = {
  NavBar: {
    Home: "首页",
    About: "关于我们",
    Mission: "使命",
    Vision: "愿景",
    Team: "团队",
    Contact: "联系",
    ContactBtn: "联系我们",
  },
  Hero: {
    badge: "为危地马拉和中美洲提供技术解决方案",
    title1: "我们用",
    titleGradient: "技术",
    title2: "转变您的业务",
    subtitle:
      "我们是一支致力于推动危地马拉和整个中美洲企业数字化增长的技术专家团队。",
    cta1: "了解更多",
    cta2: "我们的团队",
    scroll: "滚动",
    stats: { projects: "项目", clients: "客户", experience: "年经验" },
  },
  About: {
    label: "关于我们",
    title1: "连接",
    titleGradient: "未来",
    title2: "的创新",
    p1: "SIS-GT Tecnología诞生于缩小危地马拉和中美洲数字鸿沟的愿景，提供适应我们地区实际情况的世界级技术解决方案。",
    p2: "我们将本地人才与国际方法相结合，交付对客户业务产生真实可衡量影响的项目。",
    tags: ["云计算", "人工智能与自动化", "安全", "敏捷开发"],
  },
  Services: {
    items: [
      { name: "软件开发",     description: "我们使用市场上最现代的技术，为您的业务创建定制解决方案。" },
      { name: "云基础设施",   description: "通过安全、高性能的架构，在云端迁移和扩展您的业务。" },
      { name: "自动化",       description: "我们通过人工智能和工作流自动化优化您的流程。" },
      { name: "IT咨询",       description: "战略性建议，帮助您做出最佳技术决策。" },
      { name: "24/7支持",     description: "持续监控和专业技术支持，让您的业务持续运营。" },
    ],
  },
  Pillars: {
    label: "我们的支柱",
    title: "目标与方向",
    mission: {
      title: "使命",
      text: "提供创新的高质量技术解决方案，提升中美洲企业的竞争力，通过贴近、可靠、量身定制的服务，实现先进技术的民主化。",
      tags: ["创新", "质量", "承诺"],
    },
    vision: {
      title: "愿景",
      text: "成为中美洲的标杆科技公司，以智能数字化转型业务而闻名，打造推动该地区经济和社会发展的技术生态系统。",
      tags: ["领导力", "影响力", "未来"],
    },
    values: [
      { title: "卓越",   desc: "我们超越承诺" },
      { title: "透明",   desc: "始终诚实沟通" },
      { title: "敏捷",   desc: "快速适应变化" },
      { title: "协作",   desc: "与客户共同成长" },
    ],
  },
  Team: {
    label: "我们的团队",
    title1: "背后的人",
    subtitle: "一支热爱技术、致力于每位客户成功的团队。",
    members: [
      { name: "Leonel Madrid",         role: "首席执行官兼创始人",         initials: "LM", bio: "技术解决方案专家，拥有超过10年领导中美洲数字化转型项目的经验。" },
      { name: "Jorge Laj",             role: "首席技术官兼全栈开发者",     initials: "JL", bio: "全栈开发和系统架构专家，在云技术和企业解决方案方面拥有丰富经验。" },
      { name: "Luis Morales",          role: "首席愿景官兼DevOps",         initials: "LM", bio: "开发运营和产品愿景专家，在云基础设施、流程自动化和持续交付方面拥有丰富经验。" },
      { name: "Gabriel Villatoro",     role: "QA测试员",                   initials: "GV", bio: "质量保证专家，拥有功能测试、自动化测试和性能测试经验，确保产品无缺陷。" },
      { name: "Alejandro Chinchilla", role: "全栈开发者",                  initials: "AC", bio: "全栈开发者，拥有设计和构建完整Web应用的经验，涵盖用户界面到后端服务和数据库。" },
      { name: "Jordin de León",        role: "全栈开发者",                 initials: "JL", bio: "全栈开发者，擅长构建综合性Web解决方案，整合前端和后端的现代技术。" },
      { name: "Emanuel Paz",           role: "全栈开发者",                 initials: "EP", bio: "全栈开发者，专注于使用现代Web技术创建吸引人、直观且响应式的界面，致力于提供最佳用户体验。" },
      { name: "Keller Matta",          role: "后端开发者",                 initials: "KM", bio: "后端开发者，专注于可扩展架构、强大的API和数据库优化，用于高性能应用程序。" },
      { name: "Edwin Rodriguez",       role: "后端开发者",                 initials: "ER", bio: "后端开发者，拥有构建高效服务、系统集成和在生产环境中部署解决方案的经验。" },
      { name: "Daniels Castillo",      role: "前端开发者",                 initials: "DC", bio: "前端开发者，专注于使用最新Web技术构建现代、响应式且用户体验出色的界面。" },
    ],
  },
  Contact: {
    label: "联系我们",
    title1: "让我们谈谈您的",
    titleGradient: "项目",
    subtitle: "我们随时准备帮助您迈出数字化转型的下一步。",
    form: {
      name: "姓名",
      namePlaceholder: "您的姓名",
      company: "公司",
      companyPlaceholder: "您的公司",
      email: "电子邮件地址",
      emailPlaceholder: "您@公司.com",
      service: "感兴趣的服务",
      serviceDefault: "选择服务",
      message: "留言",
      messagePlaceholder: "告诉我们您的项目...",
      submit: "发送消息",
    },
    info: {
      emailLabel: "电子邮件",
      phoneLabel: "电话",
      locationLabel: "地址",
    },
  },
  Footer: { rights: "版权所有。" },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
      zh: { translation: zh },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en", "pt", "zh"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
